import { render, staticRenderFns } from "./cModalViewStock.vue?vue&type=template&id=3b0cd80e&scoped=true"
import script from "./cModalViewStock.vue?vue&type=script&lang=js"
export * from "./cModalViewStock.vue?vue&type=script&lang=js"
import style0 from "./cModalViewStock.vue?vue&type=style&index=0&id=3b0cd80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cd80e",
  null
  
)

export default component.exports